import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';

export default class Log {
  private _id: string;
  private _level: string;
  private _category: string;
  private _timestamp: number;
  private _message: string;

  constructor(
    id: string,
    level: string,
    category: string,
    timestamp: number,
    message: string
  ) {
    this._id = id;
    this._level = level;
    this._category = category;
    this._timestamp = timestamp;
    this._message = message;
  }

  get id(): string {
    return this._id;
  }

  get level(): string {
    return this._level;
  }

  get category(): string {
    return this._category;
  }

  get timestamp(): number {
    return this._timestamp;
  }

  get message(): string {
    return this._message;
  }

  static fromFirestore(
    doc: QueryDocumentSnapshot<DocumentData, DocumentData>
  ): Log {
    const docData = doc.data();

    return new Log(
      doc.id,
      docData.level,
      docData.category,
      docData.timestamp,
      docData.message
    );
  }
}
